"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _utils = require("../../utils");

var _primitives = _interopRequireDefault(require("../../primitives"));

var _excluded = ["fontSize", "color"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var propTypes = {
  children: _propTypes.node.isRequired,
  color: _propTypes.string,
  fontSize: _utils.stylePropType
};
var defaultProps = {
  color: "text-mid",
  fontSize: 2
};
/**
 * Standardized label for input fields. Basic [Text]() primitive as <label />
 * tag. Accepts all Text props except for "tag".
 */

var InputLabel = function InputLabel(_ref) {
  var _ref$fontSize = _ref.fontSize,
      fontSize = _ref$fontSize === void 0 ? 2 : _ref$fontSize,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "text-mid" : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded);

  return /*#__PURE__*/_react["default"].createElement(_primitives["default"].Text, _extends({
    color: color,
    fontSize: fontSize,
    tag: "label"
  }, props));
};

InputLabel.defaultProps = defaultProps;
InputLabel.propTypes = propTypes;
var _default = InputLabel;
exports["default"] = _default;